export const TaskPlan = {
	generated: {
		chart: '#93EA95',
	},
	plan: {
		chart: '#F6ABAB',
	},
};
